/**
 * Created by danielr on 2/23/17.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var Page = require("ui.components/page/Page");
    var ConnectorModel = require("manager-models/data-sources/conversation-sources/ConnectorModel");

    var TwilioActivationView = require("manager-views/data-sources/conversation-sources/twilio/TwilioActivationView");
    var TwilioConfigView = require("manager-views/data-sources/conversation-sources/twilio/TwilioConfigView");

    var TWILIO_ACTIVATION_PATH = "data/sources/twilio/activation";
    var TWILIO_CONFIG_PATH = "data/sources/twilio/config";

    var TwilioController = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        TwilioController = Marionette.Controller.extend({
            initialize: function(options) {
                this._initialize(options);
            },
            getMainView: function() {
                return this._getMainView();
            },
            showActivationView: function() {
                this._showActivationView();
            },
            showConfigView: function() {
                this._showConfigView();
            },

            _initialize:function () {
                LEManager.logger.debug("TwilioController:initialize");
                this.channel = LEManager.media.channel("conversationSources");

                this._bindEvents();
            },

            _bindEvents: function(){
                LEManager.logger.debug("call of _bindEvents","TwilioController:_bindEvents");

                this.listenTo(this.channel, "twilio:activation:cancel", this._onActivationCancelClick);
                this.listenTo(this.channel, "twilio:activation:next", this._onActivationNextClick);
                this.listenTo(this.channel, "twilio:config:cancel", this._onConfigCancelClick);
                this.listenTo(this.channel, "twilio:config:back", this._onConfigBackClick);
                this.listenTo(this.channel, "twilio:config:done", this._onConfigDoneClick);
            },

            _getMainView: function() {
                LEManager.logger.debug("TwilioController:getMainView - started");

                this._initPageComponent();
                return this.pageView;
            },

            _initPageComponent: function(){
                LEManager.logger.debug ("TwilioController:_initPageComponent");

                this.pageView = new Page({
                    moduleName:LEManager.moduleName,
                    context:LE.context,
                    hasActionStrip: false
                });

                /* fired when the inside page view is being closed.
                 * do not move this to _bindEvents as this should be called everytime _initPageComponent is called (when pageView is closed) */
                this.listenTo(this.pageView, "close", this._onPageClose);
            },

            _onPageClose: function(closedPageView) {
                LEManager.logger.debug("Page component in twilio is closed.", "TwilioController:_onPageClose");
                if (closedPageView) {
                    this.stopListening(closedPageView);
                }

                if (this.pageView && closedPageView && closedPageView.cid === this.pageView.cid) {
                    this.pageView = null;
                    this.insideView = null;
                }
            },

            _initData: function() {
                this.connectorsCollection = LEManager.getModuleDataManager().getConnectorsCollection();
                var twilioModels = this.connectorsCollection.getConnectorsByType(this.connectorsCollection.SOURCE_TYPES.TWILIO);

                if (_.isEmpty(twilioModels)) {
                    var configurationType = this.connectorsCollection.getConnectorConfigurationByType(this.connectorsCollection.SOURCE_TYPES.TWILIO);
                    var name = LE.translator.translate("LEManager.dataSources.conversationSources.gallery."+configurationType.key+".name");
                    this.twilioModel = new ConnectorModel({
                        name: name,
                        type: this.connectorsCollection.SOURCE_TYPES.TWILIO
                    });
                }
                else {
                    this.twilioModel = twilioModels[0]; // NOTE: Currently we support only one connector from type TWILIO
                }
                this.twilioConfigurationModel = this.twilioModel.getConfigurationModel();
            },

            _showActivationView: function() {
                LEManager.logger.debug("call of show Activation","TwilioController:_showActivationView");
                this.pageView.setTitle(LE.translator.translate("LEManager.dataSources.conversationSources.twilio.title"));
                this._initData();
                this.insideView = new TwilioActivationView({model: this.twilioModel});
                this.pageView.setInsideView(this.insideView);
            },

            _showConfigView: function() {
                LEManager.logger.debug("call of show Configuration","TwilioController:_showActivateView");
                this.pageView.setTitle(LE.translator.translate("LEManager.dataSources.conversationSources.twilio.configuration.title"));
                this._initData();

                this.insideView = new TwilioConfigView({model: this.twilioConfigurationModel});
                this.pageView.setInsideView(this.insideView);
            },

            _onActivationCancelClick: function(){
                LEManager.router.navigateBack();
            },

            _onActivationNextClick: function(){
                LEManager.logger.debug("call of _onActivationNextClick","TwilioController:_onActivationNextClick");
                var changedAttributesKeys = _.keys(this.twilioModel.changedAttributes());
                if (!_.isEmpty(_.intersection(changedAttributesKeys, [this.twilioModel.KEYS.ENABLED]))){ // We are checking if the changed attributes are one of name, description or enabled. If yes, we are saving the model.
                    LEManager.showLoader();
                    this.twilioModel.save(null, {
                        urlParameters: this.connectorsCollection.URL_PARAMETERS.ACTIVATION,
                        success: _.bind(this._onActivationSaveSuccess, this),
                        error: _.bind(this._onActivationSaveError, this)
                    });
                                    }
                else {
                    LEManager.router.navigateNonBackable(TWILIO_CONFIG_PATH);
                }
            },

            _onActivationSaveSuccess: function(model, response, options) {
                LEManager.logger.debug("connectorModel.save is successful","TwilioController:_onActivationSaveSuccess");
                LEManager.closeLoader();
                LEManager.router.navigateNonBackable(TWILIO_CONFIG_PATH);
            },

            _onActivationSaveError: function(model, response, options) {
                LEManager.logger.error("save connector model error. - TwilioController:_onActivationSaveError", model);
                LEManager.closeLoader();
                LEManager.notifier.showError(LE.translator.translate("LEManager.dataSources.conversationSources.general.activation.save.error"));
            },

            _onConfigBackClick: function(){
                LEManager.logger.debug("call of _onConfigBackClick","TwilioController:_onConfigBackClick");
                LEManager.router.navigateNonBackable(TWILIO_ACTIVATION_PATH);
            },

            _onConfigCancelClick: function(){
                LEManager.logger.debug("call of _onConfigCancelClick","TwilioController:_onConfigCancelClick");
                LEManager.router.navigateBack();
            },

            _onConfigDoneClick: function(){
                LEManager.logger.debug("call of _onConfigDoneClick","TwilioController:_onConfigDoneClick");
                LEManager.showLoader();
                this.twilioModel.save(null, {
                    urlParameters: this.connectorsCollection.URL_PARAMETERS.CONFIG,
                    success: _.bind(this._onConfigSaveSuccess, this),
                    error: _.bind(this._onConfigSaveError, this)
                });
            },

            _onConfigSaveSuccess: function(model, response, options) {
                LEManager.logger.debug("connectorModel.save is successful","TwilioController:_onConfigSaveSuccess");
                LEManager.closeLoader();

                var message = this.twilioModel.getEnabled() ? LE.translator.translate("LEManager.dataSources.conversationSources.general.config.save.success.with.activation") : LE.translator.translate("LEManager.dataSources.conversationSources.general.config.save.success.without.activation");
                LEManager.notifier.showSuccess({content: message});

                LEManager.router.navigateBack();
            },

            _onConfigSaveError: function(model, response, options) {
                LEManager.logger.error("save connector model error. - TwilioController:_onConfigSaveError", model);
                LEManager.closeLoader();
                LEManager.notifier.showError(LE.translator.translate("LEManager.dataSources.conversationSources.general.config.save.error"));
            }
        });

    }

    LE.module("LEManager", moduleDefinition);

    return TwilioController;
});
